import styled from "styled-components";
import { ToastContainer } from "react-toastify";

export const StyledContainer = styled(ToastContainer)`
  .Toastify__toast-theme--dark {
    background-color: var(--color-grey2);
  }
`;
